const url = 'https://songmaster.cz:8585/';

function saveToServer(data) {
	const http = new XMLHttpRequest();
	http.open("PUT", url + data.id);
	console.log("saving to " + data.id);
	http.send(JSON.stringify(data));
}

let last = 0;
let waiting = false;
export function checkedSave(data, resp) {
	let diff = 5000 - (Date.now() - last);
	if (diff > 1) {
		if (!waiting) {
			setTimeout(() => checkedSave(data, resp), diff);
			waiting = true;
		}
		resp(false);
		return;
	}
	last = Date.now();
	waiting = false;
	resp(true);
	saveToServer(data);
}

export function loadFromServer(ident, success) {
	const http = new XMLHttpRequest();
	http.onload = () => success(JSON.parse(http.responseText));
	http.open("GET", url + ident);
	console.log("loading from " + ident)
	http.send();
}
